module.exports = __webpack_public_path__ + "img/genevieve-harel.01afc4c1.png";